module.exports = __webpack_public_path__ + "fonts/a0e15c159eba7ef339110eca60db1e76.txt";